import { flujoEnum, userRolEnum } from "../types/enumTypes";

export const permisosActualiza: Record<flujoEnum, userRolEnum[]> = {
    [flujoEnum.revision]: [userRolEnum.revisa],
    [flujoEnum.validacion]: [userRolEnum.valida],
    [flujoEnum.publicado]: [userRolEnum.valida],
    [flujoEnum.devuelto]: [userRolEnum.carga],
    [flujoEnum.oculto]: [userRolEnum.admin],
};

const getUserRoles = (): { ControlInterno: userRolEnum }[] => {
    return JSON.parse(localStorage.getItem("Roles") || "[]");
};

export const puedeActualizar = (estatus: flujoEnum): boolean => {
    const userRoles = getUserRoles();
    const rolesPermitidos = permisosActualiza[estatus] || [];
    return userRoles.some(
        (r: { ControlInterno: userRolEnum }) =>
            rolesPermitidos.includes(r.ControlInterno) || r.ControlInterno === userRolEnum.admin
    );
};

export const puedeCrear = (): boolean => {
    const userRoles = getUserRoles();

    const rolesPermitidos = [userRolEnum.carga, userRolEnum.admin, userRolEnum.valida];

    return userRoles.some((r: { ControlInterno: userRolEnum }) =>
        rolesPermitidos.includes(r.ControlInterno)
    );
};

export const puedeBaja = (): boolean => {
    const userRoles = getUserRoles();

    const rolesPermitidos = [userRolEnum.valida, userRolEnum.admin];

    return userRoles.some((r: { ControlInterno: userRolEnum }) =>
        rolesPermitidos.includes(r.ControlInterno)
    );
};
